import { editorPrinciples } from '@/mocks/home';

export default function EditorPrinciples() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-primary-950 text-background-100">
      <div className="w-full">
        <div className="max-w-2xl mb-12">
          <span className="font-heading text-sm tracking-widest text-accent-400">编辑原则</span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl text-background-50 leading-tight">
            接收线索的边界在哪里
          </h2>
          <p className="mt-5 text-sm md:text-base leading-7 text-background-200">
            投稿入口是开放的，但发布标准不是。这四条是编辑处理每一条线索时都会对照的原则，
            也是你判断「这条线索适不适合投」的依据。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {editorPrinciples.map((p) => (
            <article
              key={p.title}
              className="flex gap-5 p-6 rounded-lg bg-background-50/8 border border-background-50/15"
            >
              <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className={`${p.icon} text-2xl`}></i>
              </span>
              <div>
                <h3 className="text-lg font-bold text-background-50">{p.title}</h3>
                <p className="mt-2.5 text-sm leading-7 text-background-200">{p.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <blockquote className="mt-12 pl-6 border-l-4 border-accent-500">
          <p className="font-heading text-xl md:text-2xl text-background-50 leading-relaxed">
            「一条线索的价值，不在于它有多劲爆，而在于它能不能被第三方复核。」
          </p>
          <footer className="mt-3 text-sm text-background-300">17吃瓜网 编辑部</footer>
        </blockquote>
      </div>
    </section>
  );
}